import { useEffect, useState } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ease } from '@/lib/motion';

interface LoginSplashProps {
  firstName: string;
  duration?: number;
  onDone: () => void;
}

export function LoginSplash({ firstName, duration = 1100, onDone }: LoginSplashProps) {
  const [phase, setPhase] = useState<'in' | 'out'>('in');
  const reduce = useReducedMotion();

  useEffect(() => {
    if (reduce) {
      const t = setTimeout(onDone, 160);
      return () => clearTimeout(t);
    }

    // Saudação aparece, segura, faz fade rápido e chama onDone.
    const t1 = setTimeout(() => setPhase('out'), duration);
    const t2 = setTimeout(() => onDone(), duration + 360);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, [duration, onDone, reduce]);

  return (
    <motion.div
      className="fixed inset-0 z-[100] flex items-center justify-center overflow-hidden bg-background px-8"
      initial={{ opacity: 0 }}
      animate={{ opacity: phase === 'out' ? 0 : 1 }}
      transition={{ duration: phase === 'out' ? 0.32 : 0.22, ease }}
      role="status"
      aria-live="polite"
    >
      <motion.h1
        className="u-h1 text-center"
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.42, ease }}
      >
        Olá, {firstName}
        <span className="u-cursor">_</span>
      </motion.h1>
    </motion.div>
  );
}
